import apiFetch from '../apiFetch'
export default function (token, body) {
  return apiFetch({ endPoint: 'AuditConfiguration', method: 'PUT', body: body, token: token })
}
